import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { textMsgList } from '../../../actions/textMessageAction';
// components
import NoData from '../../../components/NoData';
import PageHeading from '../../../components/PageHeading';
import CustomDatePicker from '../../../components/CustomDatePicker';
// Material
import Chip from '@material-ui/core/Chip';
import TodayIcon from '@material-ui/icons/Today';
import { Button } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import PropTypes from 'prop-types';
// styles
import './styles.scss';

export default function Textmessages(props) {
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [filterDate, setFilterDate] = useState('');
  //   Reducers
  const dispatch = useDispatch();
  const jwt = useSelector(state => get(state, 'loginReducer.data.jwt', {}));
  const textMessageList = useSelector(state =>
    get(state, 'textMessageReducer.data', {})
  );
  const errorMessage = useSelector(state =>
    get(state, 'textMessageReducer.errorMessage', '')
  );

  useEffect(() => {
    setIsFetching(true);
    textMsgList(jwt, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  useEffect(() => {
    setIsFetching(true);
    textMsgList(jwt, dispatch, filterDate).then(() => {
      setIsFetching(false);
    });
  }, [filterDate]);

  const populateTextMessageList = () => {
    console.log('textMessageList - ', textMessageList);
    const list = [];
    const whenLoading = [1, 1, 1, 1];
    isFetching
      ? whenLoading.map((item, index) => {
          list.push(
            <div className="text-messages-list" index={`${item}-${index}`}>
              <Skeleton className="text-messages-date" />
              <Skeleton
                className="flex-column flex-justify-center ml-20"
                width="20%"
              />
            </div>
          );
        })
      : textMessageList.map(data => {
          let check = data.MessageTime.split(' ');
          let month = check[1];
          let day = check[0];
          return list.push(
            <div className="text-messages-list">
              <div className="text-messages-date">
                <span className="day">{month}</span>
                <span className="date">{day}</span>
              </div>
              <div className="flex-column flex-justify-center ml-20">
                <div className="mobile">{data.MobileNo}</div>
                <div className="title">{data.MessageDetail}</div>
              </div>
            </div>
          );
        });
    return list;
  };

  return (
    <>
      <div className="flex-row flex-space-between align-center">
        <PageHeading titlePrimary="Text" titleSecondary="Messages" />
        <div>
          {filterDate ? (
            <Chip
              icon={<TodayIcon />}
              label={filterDate.toISOString().slice(0, 10)}
              onDelete={() => setFilterDate('')}
              color="primary"
              variant="outlined"
              className="mr-10"
            />
          ) : null}
          { props.isHidden ? '' :
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsOpen(true)}
          >
            Filter
          </Button>
        }
        </div>
      </div>
      <CustomDatePicker
        isOpen={isOpen}
        onChange={e => {
          setFilterDate(e);
        }}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
      />
      {isFetching ||
      (textMessageList != null &&
        textMessageList.length > 0 &&
        !isEmpty(textMessageList)) ? (
        <>{populateTextMessageList()}</>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
    </>
  );
}
Textmessages.propTypes = {
  isHidden: PropTypes.bool,
};